import { render, staticRenderFns } from "./NavviewNew.vue?vue&type=template&id=ae91301c&scoped=true"
import script from "./NavviewNew.vue?vue&type=script&lang=js"
export * from "./NavviewNew.vue?vue&type=script&lang=js"
import style0 from "./NavviewNew.vue?vue&type=style&index=0&id=ae91301c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae91301c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae91301c')) {
      api.createRecord('ae91301c', component.options)
    } else {
      api.reload('ae91301c', component.options)
    }
    module.hot.accept("./NavviewNew.vue?vue&type=template&id=ae91301c&scoped=true", function () {
      api.rerender('ae91301c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NavviewNew.vue"
export default component.exports